// /*global chrome*/
// import React from "react";
// import { Link } from "react-router-dom";
// import Slider from "react-slick";
// class FameWallNaati extends React.Component {
//   constructor(props) {
//      super(props);
//      this.state = {
//        homePage: false,
//        list: [],
//      };
//    } 

//   render() {
//     const pteSlider = {
//       dots: true,
//       arrows: true,
//       // infinite: true,
//       speed: 500,
//       slidesToShow: 6,
//       slidesToScroll: 1,
//       autoplay: false,
//       autoplaySpeed: 2000,
//       responsive: [
//         {
//           breakpoint: 992,
//           settings: {
//             slidesToShow: 5,
//           },
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             slidesToShow: 4,
//           },
//         },
//         {
//           breakpoint: 576,
//           settings: {
//             slidesToShow: 2,
//           },
//         },
//       ],
//     };
//     return (  
//       <>
//       <div className="our-champions-heading fm-commendable-heading">
//       <div className="container">
//         <div className="row">
//             <h2
//             className="primary-heading text-center"
//             dangerouslySetInnerHTML={{ __html: this.props.title }}
//             />
//             <p className="sub-title">Your name could be next on our champion wall.</p>
//         </div>
//         </div>  
//       </div>
//       <div className="our-champions-pte">
//         <div className="pte-slider">
//           <Slider {...pteSlider}>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-01" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-02.png" alt="fame-img-02" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-03.png" alt="fame-img-03" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-04.png" alt="fame-img-04" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-05" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-02.png" alt="fame-img-01" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-03.png" alt="fame-img-02" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-04.png" alt="fame-img-03" />
//             </div>
//           </div>
//           {/* <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-04" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/nepali2.jpg" alt="fame-img-05" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/nepali3.jpg" alt="fame-img-05" />
//             </div>
//           </div>
//           <div>
//             <div className="img-wrapper">
//               <img src="/images/web-new-images/naati/nepali4.jpg" alt="fame-img-05" />
//             </div>
//           </div> */}
//           </Slider>
//         </div>
//         <div className="d-flex justify-content-center">
//           <Link className="primary-btn" to="/scorecard">
//             <span className="btn-inner">
//               VISIT OUR WALL OF FAME{" "}
//               <img
//                 src="/images/web-new-images/right-arrow.svg"
//                 alt="Register Now"
//               />
//             </span>
//           </Link>
//         </div>
//       </div>
//     </>
//     );
//   }
// }
// export default FameWallNaati;


/*global chrome*/
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const FameWallNaati = ({show=true, title=""}) => {
  const pteSlider = {
    dots: true,
    arrows: true,
    // infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
    {
     show &&  <div className="our-champions-heading fm-commendable-heading">
        <div className="container">
          <div className="row">
            <h2
              className="primary-heading text-center"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p className="sub-title">Your name could be next on our champion wall.</p>
          </div>
        </div>
      </div>}
      <div className="our-champions-pte">
        <div className="pte-slider">
          <Slider {...pteSlider}>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-01" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-02.png" alt="fame-img-02" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-03.png" alt="fame-img-03" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-04.png" alt="fame-img-04" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-05" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-02.png" alt="fame-img-01" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-03.png" alt="fame-img-02" />
              </div>
            </div>
            <div>
              <div className="img-wrapper">
                <img src="/images/web-new-images/naati/naati-04.png" alt="fame-img-03" />
              </div>
            </div>
            {/* <div>
            <div className="img-wrapper">
              <img src="/images/web-new-images/naati/naati-01.png" alt="fame-img-04" />
            </div>
          </div>
          <div>
            <div className="img-wrapper">
              <img src="/images/web-new-images/naati/nepali2.jpg" alt="fame-img-05" />
            </div>
          </div>
          <div>
            <div className="img-wrapper">
              <img src="/images/web-new-images/naati/nepali3.jpg" alt="fame-img-05" />
            </div>
          </div>
          <div>
            <div className="img-wrapper">
              <img src="/images/web-new-images/naati/nepali4.jpg" alt="fame-img-05" />
            </div>
          </div> */}
          </Slider>
        </div>
       {
        show && (
           <div className="d-flex justify-content-center">
          <Link className="primary-btn" to="/scorecard">
            <span className="btn-inner">
              VISIT OUR WALL OF FAME{" "}
              <img
                src="/images/web-new-images/right-arrow.svg"
                alt="Register Now"
              />
            </span>
          </Link>
        </div>
        )
       }
      </div>
    </>
  );
};

export default FameWallNaati;